import { useContext } from 'react';
import UnlockTimerContext from '~/context/vdp/UnlockTimerContext';
import useIsInExclusivePreview from '~/hooks/vdp/selectors/useIsInExclusivePreview';
import OnHoldTooltip from './OnHoldTooltip';

export default function OnHoldBadge() {
  const { timeLeftAsObject, timeLeftAsShortString } =
    useContext(UnlockTimerContext);
  const isInExclusivePreview = useIsInExclusivePreview();
  const { hours, minutes, seconds } = timeLeftAsObject;

  const hasRemainder = minutes > 0 || seconds > 0;
  const wholeHours = hasRemainder ? hours + 1 : hours;
  const wholeHoursLabel = `${wholeHours} ${
    wholeHours === 1 ? 'hour' : 'hours'
  }`;
  const shouldShowWholeHours = isInExclusivePreview && hours >= 1;
  const displayText = shouldShowWholeHours
    ? wholeHoursLabel
    : timeLeftAsShortString;

  return (
    <div className="flex gap-sm">
      <OnHoldTooltip />
      <span>{displayText}</span>
    </div>
  );
}
